// An open customer's own link in the office, #/customers/<id> and #/customers/<id>/<tab>: the address
// keeps it while they're open, so a reload or a copied link opens the same customer on the same tab.
// Going to another place puts that place's link back (App.tsx), as document links do.

export const CUSTOMER_TABS = ['history', 'estimates', 'photos', 'money', 'audit'] as const;
export type CustomerTab = (typeof CUSTOMER_TABS)[number];
export interface CustomerRef {
  customerId: string;
  tab: CustomerTab;
}

export const CUSTOMER_LINK =
  /^#\/customers\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\/(history|estimates|photos|money|audit))?$/i;

/** History is the record's first tab, so its link is the customer's alone. */
export const customerHref = (customerId: string | null, tab: CustomerTab = 'history') =>
  !customerId
    ? '#/customers'
    : tab === 'history'
      ? `#/customers/${customerId}`
      : `#/customers/${customerId}/${tab}`;

export function parseCustomerLink(hash: string): CustomerRef | null {
  const m = CUSTOMER_LINK.exec(hash);
  return m
    ? { customerId: m[1]!.toLowerCase(), tab: (m[2]?.toLowerCase() as CustomerTab) ?? 'history' }
    : null;
}

/**
 * What the address asks Customers for: a customer (on a tab), the search (Customers' own link, Back to
 * it or typed: history fix 4, the customer once open leaves), or null for another place's.
 */
export function customersFromHash(hash: string): CustomerRef | 'search' | null {
  return parseCustomerLink(hash) ?? (hash === customerHref(null) ? 'search' : null);
}

/** Puts a customer's link (or Customers' own) in the address, without a step in the browser's history. */
export function markCustomer(customerId: string | null, tab?: CustomerTab): void {
  const href = customerHref(customerId, tab);
  if (location.hash !== href) history.replaceState(null, '', `${location.pathname}${location.search}${href}`);
}
